import * as React from 'react'
import { motion } from 'motion/react'

import cn from '@config/tailwind/cn'

import type { CardAction } from './card-action'

type LibrarySliderCardSize = 'large' | 'medium' | 'small'

const sizeStyles: Record<LibrarySliderCardSize, { wrapper: string; img: { width: number; height: number } }> = {
  large: { wrapper: 'srd:w-[640px] srd:h-[360px]', img: { width: 640, height: 360 } },
  medium: { wrapper: 'srd:w-[448px] srd:h-[252px]', img: { width: 448, height: 252 } },
  small: { wrapper: 'srd:w-[288px] srd:h-[216px]', img: { width: 288, height: 216 } },
}

interface LibrarySliderCardProps {
  id: string
  imageUrl: string
  action: CardAction
  size?: LibrarySliderCardSize
  className?: string
}

export function LibrarySliderCard({ id, imageUrl, action, size = 'large', className }: LibrarySliderCardProps) {
  const { wrapper, img } = sizeStyles[size]

  const content = (
    <motion.div
      data-id={id}
      whileHover={{ scale: size === 'large' ? 1.01 : 1.025 }}
      whileTap={{ scale: 0.975 }}
      className={cn('srd:cursor-pointer', wrapper, className)}
    >
      <img
        src={imageUrl}
        alt=''
        width={img.width}
        height={img.height}
        draggable={false}
        loading='lazy'
        decoding='async'
        className='srd:w-full srd:h-full srd:object-cover srd:rounded-2xl'
      />
    </motion.div>
  )

  if (action.type === 'link') return action.renderWrapper(content)
  return (
    <button type='button' onClick={action.onClick} className='srd:block'>
      {content}
    </button>
  )
}
